/**
 * Error thrown when the brain replies with an `error` frame to a
 * request. Carries the HTTP-style status code so the chat editor can
 * distinguish a 409 (occupied) from a 404 (missing) without parsing
 * the message string. `reason` carries the optional machine-readable
 * discriminator (e.g. `session_bound_elsewhere`).
 */
export class WebSocketRequestError extends Error {
    errorCode;
    type;
    reason;
    constructor(errorCode, type, message, reason) {
        super(message);
        this.errorCode = errorCode;
        this.type = type;
        this.reason = reason;
        this.name = 'WebSocketRequestError';
    }
}
/** Thrown when the connection closes before the request was answered. */
export class WebSocketClosedError extends Error {
    constructor(message = 'WebSocket connection closed') {
        super(message);
        this.name = 'WebSocketClosedError';
    }
}
//# sourceMappingURL=envelope.js.map